import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  getUserBannerStyle,
  getUserNameCosmetics,
  getNameStyleCSS,
} from "./GameNameStyles";

function getProfileBannerSrc(src) {
  if (!src) return null;

  const value = String(src);

  // Preserve query/hash if they ever exist.
  const match = value.match(/^(.+?)(\.[a-zA-Z0-9]+)([?#].*)?$/);

  if (!match) {
    return `${value}_profile`;
  }

  const [, path, extension, suffix = ""] = match;

  return `${path}_profile${extension}${suffix}`;
}

function svgFallback(name = "?") {
  const initial = (name?.[0] || "?").toUpperCase();

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64">
      <rect width="100%" height="100%" fill="#914422"/>
      <text
        x="50%"
        y="50%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="32"
        fill="#fff"
        font-family="Arial, sans-serif"
      >
        ${initial}
      </text>
    </svg>
  `;

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export default function GamesTopBar({
  user,
  onNavigate,
  onOpenProfile,

  passType = "battlepass",

  hasBattlePass = false,
  battlePassLoading = false,

  hasGamepass: hasGamepassProp,
  gamepassLoading = false,

  leaderboardParams = {},
  openedVia = "gamesTopBar",
}) {
  const trophies = Number(user?.trophies ?? 0);
  const [showPassModal, setShowPassModal] = useState(false);

  const hasGamepass =
  typeof hasGamepassProp === "boolean"
    ? hasGamepassProp
    : Boolean(
        user?.gamepass_active ??
        user?.gamepassActive
      );

const showingGamepass = passType === "gamepass";

const currentPassActive = showingGamepass
  ? hasGamepass
  : hasBattlePass;

const currentPassLoading = showingGamepass
  ? gamepassLoading
  : battlePassLoading;

const currentPassRoute = showingGamepass
  ? "gamepass"
  : "battlePass";

const currentPassLabel = showingGamepass
  ? "Game Pass"
  : "Battle Pass";

  const {
  bannerSrc,
  emojiSrc,
  nameStyle,
} = getUserNameCosmetics(user);

const bannerStyle = bannerSrc
  ? {
      ...getUserBannerStyle(user),
      backgroundImage: `url("${getProfileBannerSrc(
        bannerSrc
      )}"), url("${bannerSrc}")`,
    }
  : {
      backgroundColor: "#673a27",
      backgroundImage: "none",
    };

  const sideLabel =
    user?.side === "bad"
      ? "Anubis"
      : user?.side === "good"
      ? "Pharaohs"
      : user?.side || "";

  const openLeaderboard = () => {
  onNavigate?.("leaderboard", {
    openedVia,
    initialView: "arena-trophies",
    ...leaderboardParams,
  });
};

return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        padding: 0,
        boxSizing: "border-box",
        overflow: "visible",
        marginTop: -8,
        marginBottom: 10,
      }}
    >
      <div
        style={{
          width: "100%",
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          padding: 0,
          boxSizing: "border-box",
          overflow: "visible",
        }}
      >
       {/* USER INFO */}
<div
  onClick={() => onOpenProfile?.()}
  role="button"
  tabIndex={0}
  onKeyDown={(event) => {
    if (
      event.key === "Enter" ||
      event.key === " "
    ) {
      event.preventDefault();
      onOpenProfile?.();
    }
  }}
  aria-label="Open profile"
  style={{
    flex: "1 1 0",
    minWidth: 0,
    height: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 6,
    padding: 5,
    borderRadius: 8,
    backgroundColor: "#7d4022",
    border: "2px solid #401f0e",
    boxSizing: "border-box",
    overflow: "hidden",
    cursor: "pointer",
    ...bannerStyle,
  }}
>
        {/* USER AVATAR */}
<div
  style={{
    flex: "0 0 42px",
    width: 42,
    height: 42,
    background: "#000",
    borderRadius: 8,
    overflow: "hidden",
  }}
>
  <img
    src={
      user?.avatarUrl ||
      user?.avatar_url ||
      user?.photo_url ||
      user?.avatar ||
      svgFallback(user?.name || user?.username || "Player")
    }
    alt=""
    draggable={false}
    style={{
      display: "block",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 8,
    }}
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = svgFallback(
        user?.name ||
        user?.username ||
        "Player"
      );
    }}
  />
</div>

{/* USER EMOJI */}
{emojiSrc && (
  <div
    style={{
      flex: "0 0 42px",
      width: 42,
      height: 42,
      background: "transparent",
      borderRadius: 6,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <img
      src={emojiSrc}
      alt=""
      draggable={false}
      style={{
        display: "block",
        width: 34,
        height: 34,
        objectFit: "contain",
        borderRadius: 6,
      }}
    />
  </div>
)}

          {/* NAME AND SIDE */}
          <div
            style={{
              flex: "1 1 0",
              minWidth: 0,
              overflow: "hidden",
            }}
          >
           <div
  title={user?.name || ""}
  style={{
    display: "flex",
    alignItems: "center",
    gap: 5,
    minWidth: 0,
    textAlign: "left",
    fontSize: 15,
    fontWeight: 600,
    lineHeight: "20px",
    overflow: "hidden",
  }}
>
  <span
    style={{
      display: "inline-block",
      minWidth: 0,
      maxWidth: "100%",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      color: "#fff",
fontFamily: '"Fredoka", sans-serif',
      ...getNameStyleCSS(
        user?.active_name_style ??
        user?.activeNameStyle ??
        ""
      ),
    }}
  >
    {user?.name || user?.username || "Player"}
  </span>
</div>

            <div
              className="shadow1"
              title={sideLabel}
              style={{
                textAlign: "left",
                fontSize: 13,
                fontWeight: 600,
                color: "#f2d94b",
                lineHeight: "18px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {sideLabel}
            </div>
          </div>

          {/* TROPHIES */}
          <img
            src="/v2/trophy.png"
            alt=""
            style={{
              flex: "0 0 21px",
              width: 21,
              height: 21,
              marginLeft: 2,
              objectFit: "contain",
            }}
          />

          <span
            className="shadow1"
            style={{
              flex: "0 0 auto",
              color: "#f2d94b",
              fontSize: 15,
              fontWeight: 600,
              paddingRight: 3,
              whiteSpace: "nowrap",
            }}
          >
            {trophies}
          </span>
        </div>

        {/* LEADERBOARD */}
        <button
          type="button"
          onClick={openLeaderboard}
          aria-label="Leaderboard"
          style={{
            flex: "0 0 56px",
            width: 56,
            height: 56,
            padding: 0,
            border: 0,
            background: "transparent",
            cursor: "pointer",
          }}
        >
          <img
            src="/v2/leaderboard.png"
            alt=""
            style={{
              width: 56,
              height: 56,
              display: "block",
              pointerEvents: "none",
            }}
          />
        </button>

        {/* GAME PASS / BATTLE PASS */}
<button
  type="button"
  onClick={() => setShowPassModal(true)}
  aria-label={currentPassLabel}
  title={
    currentPassLoading
      ? `${currentPassLabel} loading`
      : currentPassActive
        ? `${currentPassLabel} active`
        : `${currentPassLabel} inactive`
  }
  style={{
    flex: "0 0 56px",
    width: 56,
    height: 56,
    padding: 0,
    border: 0,
    position: "relative",
    cursor: "pointer",
    backgroundColor: "transparent",
    backgroundImage: 'url("/v2/empty.png")',
    backgroundRepeat: "repeat",
    backgroundSize: "55px",
    backgroundPosition: "center",
  }}
>
  <img
    src={showingGamepass ? "/pass1.png" : "/pass2.png"}
    alt=""
    style={{
      width: "100%",
      height: "100%",
      padding: 8,
      boxSizing: "border-box",
      pointerEvents: "none",
    }}
  />

  <div
    className="shadow1"
    style={{
      padding: 4,
      borderRadius: 6,
      border: currentPassActive
        ? "1px solid #a2fa6b"
        : "1px solid #ff8178",
      backgroundColor: currentPassActive
        ? "#6abb38"
        : "#a83b34",
      color: "#fff",
      fontWeight: 600,
      fontSize: 10,
      lineHeight: 1,
      position: "absolute",
      top: 0,
      right: 1,
      width: "calc(100% - 2px)",
      boxSizing: "border-box",
      pointerEvents: "none",
    }}
  >
    {currentPassLoading
      ? "LOADING"
      : currentPassActive
        ? "ACTIVE"
        : "INACTIVE"}
  </div>
</button>

{showPassModal && (
  <div className="modal_box">
    <div className="modal_title">
      Choose Your Pass

      <button
        type="button"
        className="modal_close"
        onClick={() => {
          setShowPassModal(false);
        }}
      />
    </div>

    <motion.div
      className="modal_body"
      initial={{
        scale: 0.8,
        opacity: 0,
      }}
      animate={{
        scale: 1,
        opacity: 1,
      }}
      exit={{
        scale: 0.92,
        opacity: 0,
      }}
    >
      <div
        className="modal_inside modal_inside_2"
        style={{
          paddingTop: 15,
          paddingBottom: 15,
        }}
      >
        {/* OG PASS */}
        <button
          type="button"
          onClick={() => {
            setShowPassModal(false);
            onNavigate?.("gamepass");
          }}
          style={{
            display: "block",
            width: "100%",
            padding: 0,
            margin: "0 0 15px 0",
            border: 0,
            background: "transparent",
            cursor: "pointer",
          }}
        >
          <img
            src="/passbanner1.png"
            alt="OG Pass"
            draggable={false}
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              borderRadius: 8,
            }}
          />
        </button>

        {/* BATTLE PASS */}
        <button
          type="button"
          onClick={() => {
            setShowPassModal(false);
            onNavigate?.("battlePass");
          }}
          style={{
            display: "block",
            width: "100%",
            padding: 0,
            margin: 0,
            border: 0,
            background: "transparent",
            cursor: "pointer",
          }}
        >
          <img
            src="/passbanner2.png"
            alt="Battle Pass"
            draggable={false}
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              borderRadius: 8,
            }}
          />
        </button>
      </div>
      <div className="modal_footer">
<button
        type="button"
        className="game-button red-button"
        onClick={() => {
          setShowPassModal(false);
        }}
      >CLOSE</button>
      </div>
    </motion.div>
  </div>
)}

      </div>
    </div>
  );
}
